import {
  PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_BEGIN,
  PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_SUCCESS,
  PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_FAILURE,
  PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadLoginPluginConfiguration(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_BEGIN,
    });

    const { projectId, version, loginPluginCode } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/extensions/${loginPluginCode}/code/loadFields`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_SUCCESS,
            data: res.data ? res.data : '',
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadLoginPluginConfigurationError() {
  return {
    type: PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_BEGIN:
      return {
        ...state,
        loadLoginPluginConfigurationPending: true,
        loadLoginPluginConfigurationError: null,
      };

    case PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadLoginPluginConfigurationPending: false,
        loadLoginPluginConfigurationError: null,
        loginPluginDetail: action.data,
      };

    case PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_FAILURE:
      return {
        ...state,
        loadLoginPluginConfigurationPending: false,
        loadLoginPluginConfigurationError: action.data.error,
      };

    case PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_DISMISS_ERROR:
      return {
        ...state,
        loadLoginPluginConfigurationError: null,
      };

    default:
      return state;
  }
}
